import React, { Fragment, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import logo from "../images/logo.png";

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  function closeModal() {
    setIsOpen(false);
  }

  function openModal() {
    setIsOpen(true);
  }

  return (
    <div className="z-10 relative">
      <nav aria-label="Primary">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center justify-between gap-8">
            <div className="flex-shrink-0">
              <img className="h-12 w-auto" src={logo} alt="Kuhaku" />
            </div>
            <div className="hidden md:flex md:items-center md:justify-end md:flex-1">
              <div className="flex items-center gap-1">
                <a
                  href="#about"
                  className="text-gray-900 hover:bg-primary hover:text-white focus-visible:bg-primary focus-visible:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-primary px-3 py-2 rounded-md text-sm font-medium"
                >
                  About
                </a>

                <a
                  href="#works"
                  className="text-gray-900 hover:bg-primary hover:text-white focus-visible:bg-primary focus-visible:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-primary px-3 py-2 rounded-md text-sm font-medium"
                >
                  Works
                </a>

                <a
                  href="#testimony"
                  className="text-gray-900 hover:bg-primary hover:text-white focus-visible:bg-primary focus-visible:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-primary px-3 py-2 rounded-md text-sm font-medium"
                >
                  Testimony
                </a>

                <a
                  href="#team"
                  className="text-gray-900 hover:bg-primary hover:text-white focus-visible:bg-primary focus-visible:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-primary px-3 py-2 rounded-md text-sm font-medium"
                >
                  Team
                </a>

                <a
                  href="#archive"
                  className="text-gray-900 hover:bg-primary hover:text-white focus-visible:bg-primary focus-visible:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-primary px-3 py-2 rounded-md text-sm font-medium"
                >
                  Archive
                </a>
              </div>
            </div>
            <div className="-mr-0 flex md:hidden">
              <button
                onClick={openModal}
                type="button"
                className="text-primary justify-center p-2 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary rounded-md"
                aria-controls="mobile-menu"
                aria-expanded={isOpen}
                aria-label={isOpen ? "Close menu" : "Open menu"}
              >
                {!isOpen ? (
                  <svg
                    className="block h-6 w-6"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M4 6h16M4 12h16M4 18h16"
                    />
                  </svg>
                ) : (
                  <svg
                    className="block h-6 w-6"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                )}
              </button>
            </div>
          </div>
        </div>

        <Transition appear show={isOpen} as={Fragment}>
          <Dialog
            as="div"
            className="fixed inset-0 z-10 overflow-y-auto"
            onClose={closeModal}
          >
            <div className="min-h-screen px-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <Dialog.Overlay className="fixed inset-0" />
              </Transition.Child>

              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel
                  className="md:hidden absolute p-2 right-6 top-20 w-38 mt-0 inline-block align-bottom bg-white rounded-2xl text-left overflow-hidden shadow transform transition-all"
                  id="mobile-menu"
                >
                  <Dialog.Title className="sr-only">
                    Primary navigation menu
                  </Dialog.Title>
                  <div>
                    <a
                      href="#about"
                      className="block px-3 py-2 font-medium focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-primary rounded-md"
                      onClick={closeModal}
                    >
                      About
                    </a>

                    <a
                      href="#works"
                      className="block px-3 py-2 font-medium focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-primary rounded-md"
                      onClick={closeModal}
                    >
                      Works
                    </a>

                    <a
                      href="#testimony"
                      className="block px-3 py-2 font-medium focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-primary rounded-md"
                      onClick={closeModal}
                    >
                      Testimony
                    </a>

                    <a
                      href="#team"
                      className="block px-3 py-2 font-medium focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-primary rounded-md"
                      onClick={closeModal}
                    >
                      Team
                    </a>

                    <a
                      href="#archive"
                      className="block px-3 py-2 font-medium focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-primary rounded-md"
                      onClick={closeModal}
                    >
                      Archive
                    </a>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </Dialog>
        </Transition>
      </nav>
    </div>
  );
}

export default Navbar;
